<template>
  <div class="margin-bt100">
    <!--Company-->
    <div class="input-wrapper all-day-wrapper position-relative">
      <span class="ver-center">Company</span>
      <div class="pl-100 dropdown-container">
        <select
          dir
          class="custom-select add-client-insurance"
          :value="selectedInsuranceValue"
          @change="setSelectedInsuranceValue($event.target.value)"
        >
          <option :value="0" disabled>Select</option>
          <option dir="ltr" value="b" class="option-heading" disabled
            >Efile companies</option
          >
          <option
            dir="ltr"
            v-for="company in Efilecompanies"
            :key="company.insuranceCoID"
            :value="company.insuranceCoID"
            >{{ company.shortName }}</option
          >>
          <option dir="ltr" value="c" class="option-heading" disabled
            >Print companies</option
          >
          <option
            dir="ltr"
            v-for="company in printCompanies"
            :key="company.insuranceCoID"
            :value="company.insuranceCoID"
            >{{ company.shortName }}</option
          >
        </select>
      </div>
    </div>
    <div class="input-wrapper all-day-wrapper position-relative">
      <span class="ver-center">Type</span>
      <div class="pl-100 dropdown-container">
        <select
          @change="setInsuranceType($event.target.value)"
          class="custom-select insurance-type"
        >
          <option value="primary">Primary</option>
          <option value="secondary">Secondary</option>
          <option value="inactive">Inactive</option>
        </select>
      </div>
    </div>
    <div
      ref="insuranceIdDiv"
      class="input-wrapper all-day-wrapper position-relative"
    >
      <span class="ver-center">Insurance ID</span>
      <div class="pl-100">
        <input
          ref="insuranceIdInput"
          @input="setInsuranceId($event.target.value)"
          :value="insuranceId"
          type="text"
          class="title"
          placeholder
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  computed: {
    ...mapGetters({
      selectedProviderId: "getSelectedProviderID"
    }),
    ...mapGetters("addNew", {
      insuranceCompanies: "getInsuranceCompanies",
      insuranceId: "getInsuranceId",
      selectedInsuranceValue: "getSelectedInsuranceValue"
    }),
    Efilecompanies() {
      if (
        this.selectedProviderId in this.insuranceCompanies &&
        this.insuranceCompanies[this.selectedProviderId].length > 0
      ) {
        return this.insuranceCompanies[this.selectedProviderId].filter(
          company => {
            return company.eclaimSwitch === 1;
          }
        );
      } else {
        return false;
      }
    },
    printCompanies() {
      if (
        this.selectedProviderId in this.insuranceCompanies &&
        this.insuranceCompanies[this.selectedProviderId].length > 0
      ) {
        return this.insuranceCompanies[this.selectedProviderId].filter(
          company => {
            return company.eclaimSwitch !== 1;
          }
        );
      } else {
        return false;
      }
    }
  },
  methods: {
    ...mapMutations("addNew", {
      setSelectedInsuranceValue: "setSelectedInsuranceValue",
      setInsuranceType: "setInsuranceType",
      setInsuranceId: "setInsuranceId"
    })
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.insuranceIdDiv.addEventListener("click", () => {
        this.$refs.insuranceIdInput.focus();
      });
    });
  }
};
</script>

<style>
input[type="text"] {
  border-bottom: none;
  font-size: 16px;
}

.option-heading {
  font-weight: bold;
  font-size: 16px;
  color: #d26d13 !important;
  text-align: center;
}

.input-wrapper input {
  border: none !important;
}

.insurance-type {
  float: right;
  max-width: 120px;
  text-align: right;
}
</style>
